import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import fetchCurrentUserAction from '@store/actions/currentUser';
import { StoreState, IterableUserAttributes, CurrentUser } from '@root/types';

import { setBugsnagUser } from '@shared/bugsnagClient';
import useEnv from '@shared/useEnv';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';
import { parse } from 'qs';

export const userShapedForLaunchDarkly = (user: CurrentUser | null) =>
  user
    ? {
        key: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        custom: {
          market: user.marketName,
          role: user.role,
        },
      }
    : { anonymous: true };
const useUserRegisterer = () => {
  const currentUser = useSelector((state: StoreState) => state.currentUser);
  const dispatch = useDispatch();
  const fetchCurrentUser = (iterableUserAttributes: IterableUserAttributes) =>
    dispatch(fetchCurrentUserAction(iterableUserAttributes));
  const client = useLDClient();
  const { railsEnv } = useEnv();

  const ITERABLE_COOKIES = [
    'iterableEndUserId',
    'iterableEmailCampaignId',
    'iterableTemplateId',
    'iterableMessageId',
  ];
  const [cookies] = useCookies([...ITERABLE_COOKIES]);
  const { iterableEmailCampaignId, iterableTemplateId, iterableMessageId, iterableEndUserId } =
    cookies;

  const { search: urlParams } = useLocation();

  const {
    email,
    templateId: emailIterableTemplateId,
    campaignId: emailIterableCampaignId,
  } = parse(urlParams, { ignoreQueryPrefix: true });

  const decodedEmail = email ? Buffer.from(email as string, 'base64').toString() : undefined;
  const iterableUserAttributes: IterableUserAttributes = {
    iterableEndUserId: iterableEndUserId ?? decodedEmail,
    iterableEmailCampaignId: iterableEmailCampaignId ?? emailIterableCampaignId,
    iterableTemplateId: iterableTemplateId ?? emailIterableTemplateId,
    iterableMessageId,
  };

  useEffect(() => {
    fetchCurrentUser(iterableUserAttributes);
  }, [fetchCurrentUserAction]);

  useEffect(() => {
    if (railsEnv === 'test') return;

    client?.identify(userShapedForLaunchDarkly(currentUser));
    setBugsnagUser(currentUser);
  }, [currentUser, client]);

  return null;
};
export default useUserRegisterer;
